import { createClient, type SupabaseClient } from '@supabase/supabase-js';

import { HEADERS } from './constants';
import type { Database } from './database.types';

export type OctaWashClient = SupabaseClient<Database>;

export interface CreateClientArgs {
  url: string;
  anonKey: string;
  /** Código do tenant (subdominio) para envio em cabecalho. RLS usa o JWT, isso é bonus de telemetria. */
  tenantCode?: string | null;
}

/**
 * Cria um client Supabase tipado, com cabecalho de tenant e
 * persistencia de sessao no localStorage (web). Use o factory
 * único em vez de instanciar diretamente.
 */
export function createOctaWashClient({
  url,
  anonKey,
  tenantCode,
}: CreateClientArgs): OctaWashClient {
  return createClient<Database>(url, anonKey, {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
    global: {
      headers: tenantCode ? { [HEADERS.TENANT_CODE]: tenantCode } : {},
    },
  });
}
